import React, { FC } from 'react'
import { ServerExperiments } from '@/experimentation'
import { PhaseSlugForTracking } from '@/services/ProjectPhaseService'
import { ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { SweepstakeObject } from '@/types/codegen-federation'
import { useHomesteadSeriesGiveawayConfig } from '@/views/GuildGiveawayView/useHomesteadSeriesGiveawayConfig'
import { GiveawayLayout } from './../PreSales/PreSalesGiveawayView/GiveawayLayout'
import { GiveawayContextProvider } from './../PreSales/PreSalesGiveawayView/context/GiveawayContext'
import { GiveawayTypographyProvider } from './../PreSales/PreSalesGiveawayView/context/GiveawayTypographyProvider'

interface Props {
  theatricalSlug: string
  tickets: ShopifyProductWithBundles[] | null
  sweepstake: SweepstakeObject
  phase: PhaseSlugForTracking
  experiments?: ServerExperiments
  hasUser?: boolean
  releaseDate: string | null
}

export const GuildGiveawayView: FC<Props> = ({
  tickets,
  theatricalSlug,
  phase,
  sweepstake,
  experiments,
  hasUser,
  releaseDate,
}) => {
  const giveawayData = useHomesteadSeriesGiveawayConfig()

  if (!giveawayData) return null

  return (
    <GiveawayTypographyProvider theatricalSlug={theatricalSlug}>
      <GiveawayContextProvider
        theatricalSlug={theatricalSlug}
        tickets={tickets}
        sweepstake={sweepstake}
        phase={phase}
        giveawayData={giveawayData}
        experiments={experiments}
        releaseDate={releaseDate}
      >
        <GiveawayLayout hasUser={hasUser} />
      </GiveawayContextProvider>
    </GiveawayTypographyProvider>
  )
}
